/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./TakeAssessmentInstructions.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faMicrophone,
  faMicrophoneSlash,
  faVideo,
  faVideoSlash,
} from "@fortawesome/free-solid-svg-icons";
import useTakeAssessmentInstructions from "./useTakeAssessmentInstructions";
import { ASSESSMENT_ASSIGN_STATUS } from "../../../_constants/AssessmentConst";
import AssessmentHeader from "../../../_components/Common/AssessmentHeader";
import CustomImage from "../../../_components/Common/CustomImage";
export default (props) => {
  const {
    cameraAccess,
    assessmentStart,
    permissionAllowed,
    internetStatus,
    assessementDetails,
    vidRef,
    onBacktoAssessementsClick,
    onStartClick,
  } = useTakeAssessmentInstructions(props);

  return (
    <>
      <AssessmentHeader />
      {assessementDetails &&
      assessementDetails?.status === ASSESSMENT_ASSIGN_STATUS.completed ? (
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="mt-4 border border-radius-10 p-3 bg-white">
            <div className="border-bottom text-center">
              <img
                src="/assets/images/tick-green.svg"
                className="mb-2"
                alt="check"
              />
              <h3 className="mb-1">Assessment Completed</h3>
              <p className="text-grey-4 mb-3">
                You have already completed this assessment kit.
              </p>
            </div>

            <div className="border-bottom py-3 mb-3">
              <div className="flex mb-2">
                <strong className="mr-3">Title:</strong>
                <span className="text-capitalize mb-2">
                  {assessementDetails?.assessment_id &&
                    assessementDetails?.assessment_id?.title}
                </span>
              </div>

              <ul className="d-flex flex-wrap">
                <li className="mr-3">
                  <strong>Skills:</strong>
                </li>
                {Array.isArray(
                  assessementDetails?.assessment_id &&
                    assessementDetails.assessment_id?.skills &&
                    assessementDetails.assessment_id.skills
                ) &&
                  assessementDetails?.assessment_id &&
                  assessementDetails.assessment_id?.skills &&
                  assessementDetails.assessment_id.skills.map((item) => (
                    <li
                      className="bg-grey-2 text-left d-inline-block rounded h4 font-weight-normal px-2 py-1 text-capitalize"
                      key={item?.id}
                    >
                      {item.skill_id && item.skill_id?.skill}
                    </li>
                  ))}
              </ul>
            </div>
            <button
              className="btn w-100 btn-primary"
              onClick={() => onBacktoAssessementsClick()}
            >
              See Assigned Assessments
            </button>
          </div>
        </div>
      ) : (
        <div className="interviews-instructions-wrapper bg-grey text-grey-4 py-5">
          <div className="container">
            <div className="row align-items-center ">
              <div className="col-lg-8">
                <div className="video-container position-relative">
                  {permissionAllowed ? (
                    <video
                      id="player"
                      ref={vidRef}
                      autoPlay
                      style={{
                        width: "100%",
                        height: 500,
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                      muted={"muted"}
                    ></video>
                  ) : (
                    <img
                      src="/assets/images/video-thumbnail.png"
                      alt="video thumbnail"
                      className="border-radius-10"
                      style={{ width: "100%", height: 500, objectFit: "cover" }}
                    />
                  )}
                  <ul className="video-controls d-flex align-items-center justify-content-center">
                    <li className="mr-2">
                      <button className="bg-transparent border-0 p-3 text-white">
                        {cameraAccess && permissionAllowed ? (
                          <FontAwesomeIcon icon={faMicrophone} />
                        ) : (
                          <FontAwesomeIcon icon={faMicrophoneSlash} />
                        )}
                      </button>
                    </li>
                    <li>
                      <button className="bg-transparent border-0 p-3 text-white">
                        {cameraAccess && permissionAllowed ? (
                          <FontAwesomeIcon icon={faVideo} />
                        ) : (
                          <FontAwesomeIcon icon={faVideoSlash} />
                        )}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 py-4">
                <h3 className="mb-3 mt-3 mt-lg-0 text-dark">
                  Interview Instructions
                </h3>
                {cameraAccess ? (
                  <div>
                    {assessmentStart ? (
                      <div>
                        <ul className="text-grey-4">
                          <li className="d-flex align-items-start mb-3">
                            <img
                              src={"/assets/images/Check-icon.svg"}
                              alt="check"
                              className="mr-2"
                            />
                            After starting, you'll have time to read each
                            question and begin recording when you feel ready.
                          </li>
                          <li className="d-flex align-items-start mb-3">
                            <img
                              src={"/assets/images/Check-icon.svg"}
                              alt="check"
                              className="mr-2"
                            />
                            You are allowed up to 5 reloads or skips during the
                            assessment.
                          </li>
                          <li className="d-flex align-items-start mb-3">
                            <img
                              src={"/assets/images/Check-icon.svg"}
                              alt="check"
                              className="mr-2"
                            />
                            All recordings must be submitted by the specified
                            date.
                          </li>
                          <li className="d-flex align-items-start mb-3">
                            <img
                              src={"/assets/images/Check-icon.svg"}
                              alt="check"
                              className="mr-2"
                            />
                            This assessment can only be taken on Google Chrome.
                          </li>
                          <li className="d-flex align-items-start mb-3">
                            <img
                              src={"/assets/images/Check-icon.svg"}
                              alt="check"
                              className="mr-2"
                            />
                            The assessment must be completed on a web browser,
                            not on a mobile device.
                          </li>
                        </ul>
                        <p className="font-weight-medium font-italic text-dark pt-2">
                          Good luck with your assessment!
                        </p>
                        <div className="actions mt-4">
                          <button
                            className="btn btn-primary border-radius-10"
                            onClick={() => {
                              onStartClick();
                            }}
                          >
                            {assessementDetails?.status ===
                            ASSESSMENT_ASSIGN_STATUS.assigned
                              ? "Accept Assessment"
                              : assessementDetails?.status ===
                                ASSESSMENT_ASSIGN_STATUS.accepted
                              ? "Start Assessment"
                              : `Assessment ${assessementDetails?.status}`}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <ul className="text-grey-4">
                        <li className="d-flex align-items-start mb-3">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className={`text-primary mr-3`}
                          />
                          Audio and Video Compatible Device
                        </li>
                        <li className="d-flex align-items-start mb-3">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className={`${
                              permissionAllowed
                                ? "text-primary"
                                : "text-disabled"
                            } mr-3`}
                          />
                          Camera and Audio permissions allowed
                        </li>
                        <li className="d-flex align-items-start mb-3">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className={`${
                              internetStatus ? "text-primary" : "text-disabled"
                            } mr-3`}
                          />
                          {internetStatus
                            ? "Device connected to the internet."
                            : "Please connect device to the internet and reload."}
                        </li>
                      </ul>
                    )}
                  </div>
                ) : (
                  <ul className="text-grey-4">
                    <li className="d-flex align-items-start mb-2 red">
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="text-primary mr-3"
                      />
                      Please connect with a device having camera and audio
                      supported.
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
